import React, { useContext } from 'react'
import mella from '../../../assets/mella.png'
import million from '../../../assets/million-designers.png'
import { settingsContext } from '../../../Context/settingsProvider'

export default function L2() {
  const {t} = useContext(settingsContext)

  return (
    <div className='bg-[#f7f9fa] flex items-center w-full flex-col justify-center p-5 gap-4'>
        <p className='text-xl text-[#6a6f73]'>
            {t('PARTNERS')}
        </p>
        <div className='flex gap-8 items-center justify-center'>
            <img src={mella} className='w-[50px] object-contain grayscale hover:grayscale-0' />
            <img src={million} className='w-[100px] object-contain grayscale hover:grayscale-0' />
        </div>
    </div>
  )
}
